$(document).ready(function() {
    const submitButton = $('.product-form__submit');
    const drawerHeading = $('.drawer__heading');
    const drawerInner = $('.drawer__inner');

    submitButton.on('click', function() {
        drawerHeading.focus();
        trapFocus(drawerInner);
    });

    function trapFocus(element) {
        const focusableElements = element.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstFocusable = focusableElements.first();
        const lastFocusable = focusableElements.last();

        firstFocusable.focus();

        function trapFocusKeydown(event) {
            if (event.key === 'Tab') {
                if (event.shiftKey) {
                    if ($(document.activeElement).is(firstFocusable)) {
                        event.preventDefault();
                        lastFocusable.focus();
                    }
                } else {
                    if ($(document.activeElement).is(lastFocusable)) {
                        event.preventDefault();
                        firstFocusable.focus();
                    }
                }
            }
            if (event.key === 'Escape') {
                element.off('keydown', trapFocusKeydown);
                submitButton.focus();
            }
        }
        element.on('keydown', trapFocusKeydown);
    }
});


// $(document).ready(function() {
//     const quickViewButton = $('.card__link.button.quick-view');
//     const fancyboxOverlay = $('.fancybox-wrap.fancybox-desktop.fancybox-type-inline.fancybox-opened');
//     const trapp = $('.fancybox-overlay.fancybox-overlay-fixed');

//     quickViewButton.on('click', function(event) {
//         event.preventDefault();

//         setTimeout(function() {
//             fancyboxOverlay.focus();

//             trapFocus(trapp);
//         }, 2000);
//     });

//     function trapFocus(element) {
//         const focusableElements = element.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
//         const firstFocusable = focusableElements.first();
//         const lastFocusable = focusableElements.last();

//         firstFocusable.focus();

//         function trapFocusKeydown(event) {
//             if (event.key === 'Tab') {
//                 if (event.shiftKey) {
//                     if ($(document.activeElement).is(firstFocusable)) {
//                         event.preventDefault();
//                         lastFocusable.focus();
//                     }
//                 } else {
//                     // Tab, focus on the first focusable element if the last is focused
//                     if ($(document.activeElement).is(lastFocusable)) {
//                         event.preventDefault();
//                         firstFocusable.focus();
//                     }
//                 }
//             }
//             if (event.key === 'Escape') {
//                 // Escape key, remove event listener and focus on the quick view button
//                 element.off('keydown', trapFocusKeydown);
//                 quickViewButton.focus();
//             }
//         }

//         // Add event listener for keydown event
//         element.on('keydown', trapFocusKeydown);
//     }
// });
